export { default, createFilterOptions } from './useAutocomplete';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/useAutocomplete/index.js
// module id = 907
// module chunks = 2